import React from 'react';
import PropTypes from 'prop-types';
import { VaLink } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import recordEvent from 'platform/monitoring/record-event';
import { getScorecardUrl } from '../../utils/helpers';

export const USC_3698_URL =
  'https://www.govinfo.gov/content/pkg/USCODE-2024-title38/pdf/USCODE-2024-title38-partIII-chap36-subchapIII-sec3698.pdf';

export default function ScorecardDisclaimer({ institution }) {
  const handleClick = () =>
    recordEvent({
      event: 'cta-button-click',
      'button-type': 'primary',
      'button-click-label': 'View College Scorecard',
      'school-name': institution.name,
    });

  return (
    <div className="vads-u-padding-x--2 vads-u-padding-top--2 vads-u-padding-bottom--1 vads-u-border-top--4px vads-u-border-color--white">
      <p>
        U.S. Department of Education maintains data about costs, student debt,
        graduation rates, admissions test scores and acceptance rates, student
        body diversity, post-college earnings, and more.
      </p>
      <a
        className="usa-button vads-u-margin-bottom--0 vads-u-margin-top--0"
        href={getScorecardUrl(institution)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        View College Scorecard
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
      <p>
        *In accordance with{' '}
        <VaLink
          href={USC_3698_URL}
          text="38 U.S.C. § 3698(c)"
          external
          data-testid="usc-3698-link"
        />
        , the VA must publish statistics on student debt, graduation rates, and
        employment income. Because Veterans make up a small percentage of
        education benefit users, privacy laws (34 CFR&nbsp;§&nbsp;99.31(b)(1))
        and 38 USC 3698(c)(2)(C) limit our ability to release such detailed
        data. To help Veterans compare providers and programs, the VA links to
        general statistics on the U.S. Department of Education’s Scorecard Tool.
        A Veteran-focused page within the Scorecard also provides available
        Veteran-specific statistics when privacy rules allow.
      </p>
    </div>
  );
}

ScorecardDisclaimer.propTypes = {
  institution: PropTypes.shape({
    cross: PropTypes.string,
    name: PropTypes.string,
    scorecard: PropTypes.string,
  }).isRequired,
};
